export default [
  {
    name: 'VersionamentoBdgd',
    path: 'versionamento-bdgd',
    component: () => import('@/views/versionamentoBdgd/Index.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      routeReleasedForLite: true,
      breadcrumb: [
        { name: 'Administração', path: '/administracao' },
        { name: 'Versionamento BDGD', path: '/administracao/versionamento-bdgd' }
      ]
    }
  }
];
